import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { FilmmakerScopeProvider } from "./context/FilmmakerScope";
import { Toaster } from "sonner";

import Home from "./pages/Home";
import About from "./pages/About";
import Login from "./pages/Login";
import Register from "./pages/Register";
import FilmMiniSite from "./pages/FilmMiniSite";
import Checkout from "./pages/Checkout";
import Library from "./pages/Library";
import Admin from "./pages/Admin";
import AdminSales from "./pages/AdminSales";
import AdminFilmmakers from "./pages/AdminFilmmakers";
import BoxOffice from "./pages/BoxOffice";
import FilmmakerPage from "./pages/FilmmakerPage";
import CheckoutReturn from "./pages/CheckoutReturn";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <FilmmakerScopeProvider>
          <Toaster richColors position="top-center" />
          <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/library" element={<Library />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/sales" element={<AdminSales />} />
          <Route path="/admin/filmmakers" element={<AdminFilmmakers />} />
          <Route path="/box-office" element={<BoxOffice />} />
          <Route path="/f/:slug" element={<FilmmakerPage />} />
          <Route path="/film/:slug" element={<FilmMiniSite />} />
          <Route path="/film/:slug/checkout" element={<Checkout />} />
          <Route path="/film/:slug/return" element={<CheckoutReturn />} />
          <Route path="*" element={<Home />} />
          </Routes>
        </FilmmakerScopeProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
